import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'
import { DragDropContext } from 'react-beautiful-dnd'

import { validateSearchResults } from '../../functions'

import Contact from './contact'

class Contacts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isDragging: false,
      sourceDroppableId: undefined
    }
  }

  render() {
    const { view, contacts } = this.props
    const { isDragging } = this.state

    return (
      <section className="contacts">
        <div className="section-head">
          <h2>Contacts</h2>
        </div>

        <ol className="cards">
          {
            contacts.map((contact, index) => {
              return (
                <Contact key={index}
                  view={view}
                  contact={contact}
                  position={index+1}
                  isDragging={isDragging}
                  removeRiderContact={this.props.removeRiderContact}
                  createRiderContact={this.props.createRiderContact}
                  editRiderContact={this.props.editRiderContact}
                  deleteRiderContact={this.props.deleteRiderContact}
                  setAlert={this.props.setAlert} />
              )
            })
          }

          {
            view.editable
            ? <li className="card card--add" onClick={() => {
                this.props.addRiderContact({
                  id: undefined,
                  name: null,
                  email: null,
                  phone: null,
                  items: []
                })
              }}>
                <div className="card-content" data-number={contacts.length+1}>
                  <h1 className="add-contact">+</h1>

                  <p>Add new contact</p>
                </div>
              </li>
            : null
          }
        </ol>
      </section>
    )
  }
}

Contacts.propTypes = {
  view: PropTypes.object,
  contacts: PropTypes.array,
  addRiderContact: PropTypes.func,
  removeRiderContact: PropTypes.func,
  createRiderContact: PropTypes.func,
  editRiderContact: PropTypes.func,
  moveRiderContact: PropTypes.func,
  deleteRiderContact: PropTypes.func,
  setAlert: PropTypes.func
}

Contacts.defaultProps = {
  view: {},
  contacts: [],
  addRiderContact: function() {},
  removeRiderContact: function() {},
  createRiderContact: function() {},
  editRiderContact: function() {},
  moveRiderContact: function() {},
  deleteRiderContact: function() {},
  setAlert: function() {}
}

export default Contacts



// WEBPACK FOOTER //
// ./src/components/rider/rider-contacts/contacts.js